import dayjs from "dayjs";
import "dayjs/locale/ko";
dayjs.locale("ko");
import 'swiper/css/bundle';
import Swiper from 'swiper/bundle';

const formCheck = ($form) => {
    if (!$form || !$form.length) return false;
    
    let chk = true;

    $form.find('input, select, textarea').each((i, v) => {
        if (v.value === '' && $(v).data('optional') !== "skip") {
            alert($(v).data('check'));
            $(v).focus();
            chk = false;
            return false;
        }
    });

    return chk;
};

const updateTotalPrice = () => {
  const datePay = parseInt(document.querySelector('#upgrade-date input[type="checkbox"]')?.value || 0);
  const roomPay = parseInt(document.querySelector('#upgrade-room input[name="room_opt"]:checked')?.value || 0);

  const total = datePay + roomPay;

  const target = document.getElementById('upgrade-price');
  if (target) {
    target.textContent = `업그레이드 요금 ${total.toLocaleString()}원`;
  }
};

// 객실예약
$('.step-wrapper .menu-wrap .menu').click((e) =>{
    $(e.currentTarget).find('ul').toggle();
})


$('.step1-wrap .btn').click((e) =>{
    const $form = $('#step1form')
    const chk = formCheck($form)

    if(chk == true) {
        $form.submit();
    }
})

// 이용권안내
$('.step2-wrap .Membership-wrap .num').click((e) =>{
    $('.step-wrapper .popupMore').show()
})

$('.popupMore .btn-close').click((e) =>{
    $('.step-wrapper .popupMore').hide()
})

// 달력
$('.step2-wrap .btn-cal, .step6-wrap .btn-cal').click((e) =>{
    $('.step-wrapper .popupCal').css('top',0)
})

$('.popupCal .btn-close, .popupCal .btn-wrap').click((e) =>{
    $('.step-wrapper .popupCal').css('top','100%')
})
// 인원
$('.step2-wrap .btn-person').click((e) =>{
    $('.step-wrapper .popupPer').show()
})

$('.popupPer .btn-close, .popupPer .btn-wrap').click((e) =>{
    $('.step-wrapper .popupPer').hide()
})

$('.btn-modify').on('click', () => {
    const isEditing = $('.btn-modify').text() === "수정";
    $('#phone-input').prop('readonly', !isEditing).toggleClass('editing', isEditing);
    $('.btn-modify').text(isEditing ? "확인" : "수정").toggleClass('btn-editing', isEditing);

    if(!isEditing) {                
        fetch('/reserve/mypage', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': $('meta[name=csrf-token]').attr('content'),
            },
            body: JSON.stringify({
                tel:  $('#phone-input').val(),
            }),
        })
        .then((response) => response.json())
        .then((result) => {      
            alert('수정되었습니다.')
        })
    }
});


const formatCal = ((startDate, mode) => {
    const formatDate = (date) => mode ? dayjs(date).locale('ko').format('MM.DD (ddd)') : dayjs(date).locale('ko').format('MM.DD');
    // const nights = dayjs(endDate).diff(dayjs(startDate), 'day');
    const endDate =  dayjs(startDate).add(1, 'day')
    $('.cal_result').text(`${formatDate(startDate)} ~ ${formatDate(endDate)} / 1박`);
    $('input[name=chkin]').val(dayjs(startDate).locale('ko').format('YYYY-MM-DD'))
    $('input[name=chkout]').val(dayjs(endDate).locale('ko').format('YYYY-MM-DD'))
})

flatpickr(".showcal", {
    minDate: new Date(),
    maxDate: function() {
        const endDateVal = $("#end_date").val();
        const endDate = new Date(endDateVal);
        const today = new Date();
        const date90 = new Date(today);
        date90.setDate(today.getDate() + 90);
        return endDate < date90 ? endDate : date90;
    }(),
    defaultDate: (() => {
        const params = new URLSearchParams(window.location.search);
        const sdate = params.get("sdate");
        return sdate ? new Date(sdate) : new Date();
    })(),
    disableMobile: "true",
    locale: "ko",
    inline: true,
    showMonths: window.innerWidth <= 768 ? 1 : 2,
    disable: [            
        {
            from: "2024-12-20",
            to: "2025-01-05"
        },        
    ],
    onReady: (() => {
        const params = new URLSearchParams(window.location.search);
        const sdate = params.get("sdate") ?? $("#sdate").val();
        const edate = params.get("edate") ?? $("#edate").val();

        formatCal(sdate, edate, 'w');
    }),
    onValueUpdate: (selectedDates) => {
        if (selectedDates.length > 0) {
            const sdate = selectedDates[0].toLocaleDateString('sv-SE');

            const edateObj = new Date(selectedDates[0]);
            edateObj.setDate(edateObj.getDate() + 1);
            const edate = edateObj.toLocaleDateString('sv-SE');

            if (window.location.pathname === "/reserve/mypage") {
                formatCal(sdate, edate, 'w');
            } else {
                const url = new URL(window.location.href);
                url.searchParams.set("sdate", sdate);
                url.searchParams.set("edate", edate);
                window.location.href = url.toString();
            }
        }
    }
});

document.querySelectorAll('.sub-box li').forEach(li => {
    li.addEventListener('click', () => {
        const radio = li.querySelector('input[type="radio"]');

        if(radio && !radio.checked) {
            radio.checked = true;
        }

        const ridx = radio.dataset.ridx;
        const price = Number(radio.value);
        const name = li.querySelector('label p')?.textContent?.trim();
        
        $("input[name=room_type]").val(ridx);

        const upgrade = document.querySelector('.upgrade-room');

        if(price > 0) {
            const formattedPrice = price.toLocaleString();

            if(upgrade) {
                upgrade.querySelector('.info').textContent = `${formattedPrice}원`;
            } else {
                const add = `
                    <li class="upgrade-room">
                        <p class="tit">객실 업그레이드</p>
                        <p class="info">${formattedPrice}원</p>
                    </li>
                `;
                $("#add-opt").append(add).show();
            }
        } else {
            if(upgrade) upgrade.remove();
        }

        ReservationOrderCalc();
    });
});

const updateValue = (step, cur) => {
    let input = $(cur).siblings('.numInput');
    let value = Math.max(0, +input.val() + step);
    input.val(value);       
    $('.per_result').text(value);

    ReservationOrderCalc();
};

$('.btn-decrement').click((e) => updateValue(-1, $(e.currentTarget)));
$('.btn-increment').click((e) => updateValue(1, $(e.currentTarget)));

const ReservationOrderCalc = () => {
    const sendData = {};

    sendData['breakfast']       = $("input[name=breakfast]").val();
    sendData['breakfast_adult'] = $("input[name=b_adult]").val();
    sendData['breakfast_child'] = $("input[name=b_child]").val();
    sendData['pool']            = $("input[name=pool]").val();
    sendData['pool_adult']      = $("input[name=p_adult]").val();
    sendData['pool_child']      = $("input[name=p_child]").val();
    sendData['upgrade']         = document.getElementById("view").checked ? 1 : 0;
    sendData['pet']             = document.getElementById("petroom").checked ? 1 : 0;
    sendData['room_type']       = $("input[name=room_type]").val();
    sendData['upgrade_date']    = $("input[name=upgrade_date]").val();
    sendData['upgrade_room']    = $("input[name=upgrade_room]:checked").val();

    fetch("/reserve/mypage/state/calc", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "X-CSRF-TOKEN": $("meta[name=csrf-token]").attr("content"),
        },
        body: JSON.stringify(sendData),
    })
    .then((response) => response.json())
    .then((data) => {
        const buy_use = Number(data.breakfast.use_adult) + Number(data.breakfast.use_child) + Number(data.pool.use_adult) + Number(data.pool.use_child),
                add_breakfast = Number(data.breakfast.add_adult) + Number(data.breakfast.add_child),
                add_pool = Number(data.pool.add_adult) + Number(data.pool.add_child)
        
        $("input[name=add_break]").val(data.breakfast.add_pay);
        $("input[name=add_pool]").val(data.pool.add_pay);
        $("input[name=upgrade]").val(data.upgrade);
        $("input[name=pet]").val(data.pet);
        $("input[name=total]").val(data.total);
        

        $("#buy-use").html(buy_use + "매");
        $("#buy-breakfast").html("대인 " + data.breakfast.use_adult + ", 소인 "  + data.breakfast.use_child);
        $("#buy-pool").html("대인 " + data.pool.use_adult + ", 소인 "  + data.pool.use_child);

        if(add_breakfast > 0) {
            $(".add-breakfast").remove();

            var breakfast = `<li class="add-breakfast">
                        <p class="tit">조식</p>
                        <p class="info">대인 ${data.breakfast.add_adult} , 소인 ${data.breakfast.add_child}</p>
                    </li>`;
            $("#add-opt").append(breakfast).show(); 
        } else {
            $(".add-breakfast").remove();
        }

        if(add_pool > 0) {
            $(".add-pool").remove();

            var pool = `<li class="add-pool">
                        <p class="tit">수영장</p>
                        <p class="info">대인 ${data.pool.add_adult} , 소인 ${data.pool.add_child}</p>
                    </li>`;
            $("#add-opt").append(pool).show(); 
        } else {
            $(".add-pool").remove();
        }

        $(".total").html(Number(data.total).toLocaleString() + "원");
    })
};

// 예약취소 
$('.step-wrapper .btn-cancel').click(() => {
    const str = {
        chkin: document.getElementById('chkin').innerText,
        room: document.getElementById('room-name').innerText,
        no: document.getElementById('no').value,
    }

    let msg = `일자 : ${str.chkin}\n객실 : ${str.room}\n\n예약 취소접수를 하시겠습니까?`;


    if(confirm(msg) == true) {
        fetch("/reserve/mypage/reservation/cancel", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-CSRF-TOKEN": $("meta[name=csrf-token]").attr("content"),
            },            
            body: JSON.stringify({                    
                num:  str.no,
            }),
        })
        .then((response) => response.json())
        .then((data) => {
            if(data.res == 200) {
                alert("예약 취소가 접수되었습니다.");
                location.href = `/reserve/mypage/reservation/${data.no}`;            }
        })
    }

});

$('.step5-wrap .ticket').click((e) => {
    $(e.currentTarget).next().toggleClass('active')
})

var ticketSwipers = [];
                
$('.step5-wrap .swiper-container').each(function(i) {
    var r_i = $(this).attr('id');
    
    ticketSwipers[i] = new Swiper('#'+r_i, {	
        slidesPerView: 1,
        spaceBetween: 10,
        pagination: {
            el: '.swiper-pagination.'+r_i,
        },    
        breakpoints: {
            768: {
                slidesPerView: 'auto',
            }
        }
    })
})

$(window).resize(function() {
    if ($(window).width() <= 768) {
        $('.possession .cuts').each(function() {  
            let currentCutCount = $(this).find('.cut').length;
            let cutsToAdd = 12 - currentCutCount;

            if (cutsToAdd > 0) { 
                for (let i = 0; i < Math.min(cutsToAdd, 7); i++) { 
                    $(this).append('<div class="cut"></div>');
                }
            }
        });
    } else {
        $('.possession .cuts').each(function() {
            $(this).find('.cut').remove();
            for (let i = 0; i < 5; i++) {
                $(this).append('<div class="cut"></div>');
            }
        });
    }
}).resize(); 

$('.popupfct .selectBox').click((e) => {
    $(e.currentTarget).next().toggleClass('active')
})

let optchk

$('.possession .open-popupfct ').click((e) => {
    if (/Mobi|Android/i.test(navigator.userAgent)) {
        const dataType = e.currentTarget.dataset.type,
            dataUno = e.currentTarget.dataset.uno,
            sendData = {};

        sendData['type']    = dataType;        
        sendData['uno']     = dataUno;

        fetch('/reserve/mypage/available-tickets', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': $('meta[name=csrf-token]').attr('content'),
            },
            body: JSON.stringify(sendData),
        })
        .then((response) => response.json())
        .then((result) => {
            $('#utype').val(dataType)
            $('#f-name').html(result.ticket)
            $('#f-cnt').html(result.count)
            $('.popupfct .option').html(result.list)
        });

        $('.popupfct.step1').show()
        $('body').addClass('on')    
    } else {
        alert("이용권 현장사용을 위해 모바일(휴대폰)로 접속해주세요.");
    }
})

$('.popupfct .option').on('click', 'li', (e) => {
    let fctVal = $(e.currentTarget).text()
    let fct = $(e.currentTarget).data('num')
    $('.fctVal').text(fctVal)
    $('#ucount').val(fct)
    $('.popupfct .option').removeClass('active')
    $('.popupfct.step1 .btn-use').addClass('active')
    optchk = true;
})

const optionReset = () => {
    $('.fctVal').text('수량 선택')
    $('#ucount').val('')
    $('.popupfct.step1 .btn-use').removeClass('active')
    optchk = false;
}

$('.popupfct .btn-close').click((e) => {
    $('.popupfct').hide()
    $('body').removeClass('on')
    optionReset()
})


$('.popupfct.step1 .btn-use').click((e) => {
    if(optchk){
        const data = $('#fctform').serializeArray(),
            sendData = {};

        for (let i = 0; i < data.length; i++){
            sendData[data[i]['name']] = data[i]['value'];
        }

        fetch('/reserve/mypage/use-facil-tickets-check', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': $('meta[name=csrf-token]').attr('content'),
            },
            body: JSON.stringify(sendData),
        })
        .then((response) => response.json())
        .then((result) => {
            if(result.res == 200) {
                $('input[name=type]').val(result.type);
                $('input[name=cnt]').val(result.ea);
                $('.f-type').html(result.type);
                $('.f-cnt').html(result.ea);
                $('.popupfct.step2').show()
            } else {
                alert(result.msg);
            }
        })
    }
})
$('.popupfct.step2 .btn-use').click((e) => {
    const data = $('#u-form').serializeArray(),
            sendData = {};

    for (let i = 0; i < data.length; i++){
        sendData[data[i]['name']] = data[i]['value'];
    }

    fetch('/reserve/mypage/use-facil-tickets', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRF-TOKEN': $('meta[name=csrf-token]').attr('content'),
        },
        body: JSON.stringify(sendData),
    })
    .then((response) => response.json())
    .then((result) => {
        if(result.res == 200) {
            $('.f-type').html(result.type);
            $('.f-cnt').html(result.ea);
            $('.popupfct.step3').show()
        } else {
            alert(result.msg);
        }
    });       
})

const roomurl = 'https://img.iparksuite-sokcho.com/room/'
const roomData = {
    "파셜오션뷰디럭스더블": { 
        title: ["파셜오션뷰디럭스더블"],
        image: ["Deluxe_Double/"],
        length: [7]
    },
    "파셜오션뷰디럭스더블트윈/온돌": { 
        title: ["파셜오션뷰디럭스더블트윈", "파셜오션뷰디럭스더블온돌"],
        image: ["Deluxe_DoubleTwin/", "Deluxe_Ondol/"],
        length: [8, 9]
    },
    "파노라마오션뷰스위트패밀리": { 
        title: ["파노라마오션뷰스위트패밀리"],
        image: [ "Suite_Family/"],
        length: [6]
    },
}

var popupImgThumbsSwiper
var popupImgSwiper

const initPopupswiper = () => {
    popupImgThumbsSwiper = new Swiper('.popupImg .swiper .thumbs', {
        loop: true,
        spaceBetween: 10,
        slidesPerView: 5,
        freeMode: true,
        watchSlidesProgress: true,
        breakpoints: {
            768: {
                slidesPerView: 10,
            },
        },
    });
    
    popupImgSwiper = new Swiper('.popupImg .swiper .main', {
        loop: true,
        pagination: {
            el: ".swiper-pagination.main",
            type: "fraction",
          },
        navigation: {
          nextEl: '.swiper-button-next.main',
          prevEl: '.swiper-button-prev.main',
        },
        thumbs: {
            swiper: popupImgThumbsSwiper,
        },
        on: {
            init: function() {
                // Swiper가 완전히 초기화된 후 popupImg 요소를 보여줌
                $('.popupImg').show();
            },
            slideChange: function () {
                $('.popupImg .title-wrap .title').each((idx, el) => {
                    if($(el).attr('data-slideNum') <= this.realIndex){
                        $('.popupImg .title-wrap .title').removeClass('active')
                        $(el).addClass('active')
                    }
                })
            }
        }
    });
}

// $('.step6-wrap .list-wrap li').each(function() {
//     // 해당 li 내의 input 값 가져오기 (상품 이름)
//     let roomName = $(e.currentTarget).find('input').val();
    
//     // 리스트 img 수정
//     if (roomData[roomName]) {
//         $(this).find('img').attr('src', roomurl + roomData[roomName].image[0] + '01.jpg');
//     }
// });

$('.step6-wrap .btn-img').click((e) => {
    let roomName = $(e.currentTarget).parents('li').find('input').val();
    
    // 팝업 img, title 수정
    if (roomData[roomName]) {
        let curRoom =  roomData[roomName]
        curRoom.image.forEach(function(img, idx) {
            $('.popupImg .title-wrap').append(
                `<div class="title ${idx ? '' : 'active'}" data-slideNum="${curRoom.length.slice(0, idx).reduce((acc, val) => acc + val, 0)}">
                    ${curRoom.title[idx]}
                </div>`
            );
            for (let i = 1; i <= curRoom.length[idx]; i++) {
                let imgUrl = roomurl + img + (i < 10 ? '0' + i : i) + ".jpg";
                $('.popupImg .swiper-wrapper').append(
                    `<div class="swiper-slide">
                        <img src="${imgUrl}" alt="${curRoom.title[idx]}" class="img">
                    </div>`
                );
            }
        })
    }
    // html 추가후 스와이퍼 초기화
    initPopupswiper();
})

$('.popupImg .btn-close').click((e) => {
    $('.popupImg .title-wrap').empty();
    $('.popupImg .swiper-wrapper').empty();
    $('.popupImg').hide()
})

$('.popupImg .title-wrap').on('click','.title', (e) => {
    let slideNum = $(e.currentTarget).attr('data-slideNum')
    
    // 탭 스와이퍼 이동
    popupImgSwiper.slideTo(slideNum, 0, false)
    $('.popupImg .title-wrap .title').removeClass('active');
    $(e.currentTarget).addClass('active');
    
})

$('.step6-wrap .rsv-btn, .step6-wrap .btnRed').click((e) => {
    const dataIdx = e.currentTarget.dataset.idx,
        dataRoom = e.currentTarget.dataset.room

    fetch('/reserve/state/upgrade', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRF-TOKEN': $('meta[name=csrf-token]').attr('content'),
        },
        body: JSON.stringify({
            ticket: dataIdx,
            sdate:  $('input[name=chkin]').val(),
        }),
    })
    .then((response) => response.json())
    .then((result) => {
        console.log(result)
        $('input[name=tid]').val(dataIdx)
        $('input[name=room_name]').val(dataRoom)
        $('input[name=room_type]').val(result.room_type)
        
        if(result.layer) {                
            const dateSection = document.getElementById('upgrade-date');
            const roomSection = document.getElementById('upgrade-room');

            dateSection.innerHTML = '';
            roomSection.innerHTML = '';

            if(result.date && result.date.pay > 0) {
                const label = document.createElement('div');
                label.innerHTML = `
                    <h5>날짜 업그레이드</h5>
                    <ul class="box">
                        <li class="active">
                            <input type="checkbox" id="up-date" name="date_opt" value="${result.date.pay}" checked disabled>
                            <label for="up-date">
                                <div class="txt">${result.date.present} → ${result.date.upgrade}</div>
                                <div class="num">${result.date.pay.toLocaleString()}원</div>
                            </label>
                        </li>
                    </ul>
                `;
                    
                dateSection.appendChild(label);

                $('input[name=up_date_pay]').val(result.date.pay);
                $('input[name=up_date_info]').val(result.date.present + ' → ' + result.date.upgrade);

                updateTotalPrice();
            }
            
            if(result.room && Object.keys(result.room).length > 1) {                                               
                const sortedEntries = Object.entries(result.room).sort((a, b) => {
                    const aPay = typeof a[1].pay === 'number' ? a[1].pay : 0;
                    const bPay = typeof b[1].pay === 'number' ? b[1].pay : 0;
                    return aPay - bPay;
                });

                const roomBox = document.createElement('ul');
                roomBox.className = 'box';

                sortedEntries.forEach(([roomId, room], index) => {
                    const li = document.createElement('li');
                    if (index === 0) li.classList.add('active');

                    const input = document.createElement('input');
                    input.type = 'radio';
                    input.name = 'room_opt';
                    input.id = `room-${roomId}`;
                    input.value = typeof room.pay === 'number' ? room.pay : 0;
                    input.dataset.room = roomId;
                    input.dataset.name = room.name;
                    if (index === 0) input.checked = true;

                    const label = document.createElement('label');
                    label.setAttribute('for', `room-${roomId}`);

                    const txtDiv = document.createElement('div');
                    txtDiv.className = 'txt';
                    txtDiv.textContent = room.name;

                    const numDiv = document.createElement('div');
                    numDiv.className = 'num';
                    numDiv.textContent = (typeof room.pay === 'number')
                        ? `${room.pay.toLocaleString()}원`
                        : room.pay;

                    label.appendChild(txtDiv);
                    label.appendChild(numDiv);

                    li.appendChild(input);
                    li.appendChild(label);
                    roomBox.appendChild(li);

                    $('input[name=up_room_detail]').val(JSON.stringify(result.room));
                });
                
                const title = document.createElement('h5');
                title.textContent = '객실 업그레이드';
                roomSection.appendChild(title);
                roomSection.appendChild(roomBox);

                roomBox.querySelectorAll('li').forEach(li => {
                    li.addEventListener('click', () => {                            
                        const radio = li.querySelector('input[type="radio"]');
                        if (radio && !radio.checked) {
                            radio.checked = true;
                        }

                        roomBox.querySelectorAll('li').forEach(el => el.classList.remove('active'));
                        li.classList.add('active');

                        const pay = parseInt(radio.value) || 0;
                        const name = li.querySelector('.txt')?.textContent?.trim() || '';

                        $('input[name=up_room_pay]').val(pay);
                        $('input[name=up_room_info]').val(name);
                        $('input[name=room_type]').val(radio.dataset.room);
                        

                        updateTotalPrice();
                    });
                });
            }
            updateTotalPrice();
            $('.popupUpgrade').show()
        } else {                
            document.getElementById('rform')?.submit();
        }
    })
})

document.getElementById('upgrade-submit')?.addEventListener('click', () => {
    document.getElementById('rform')?.submit();
});

$('.step7-wrap .agree .info').click((e) => [
    $('.check-list').toggle()
])

$('.step7-wrap .option').on('change', function() {
    let $this = $(this);
    $this.siblings('.sub-box').toggle(this.checked);
    // 객실 변경시 초기화
    if ($this.attr('name') === 'room_type') {
        $('.step7-wrap .form-wrap')
            .find('input[type="checkbox"]').prop('checked', false).end()
            .find('input[type="num"]').val(0);
        $('.sub-box').hide();
        $(".facil").remove();
    }
    
    // 리셋
    if(!this.checked){
        $(this).siblings('.sub-box').find('input, select').each(function (i, el) {
            $(el).val(0).trigger('change')
        })
    }

    ReservationOrderCalc();
});

$(".radio_checkbox").on('change', function () {
    let ondolChecked = $('input[value="949477"]').is(":checked");
    let petroom = $("#petroom");

    $(".radio_checkbox").not(this).prop("checked", false); // 다른 체크박스 선택 해제
    $(".facil").remove();

    $(".radio_checkbox").each(function () {
        // 온돌 펫룸 체크해제
        if (ondolChecked && petroom.is(':checked')) {
            petroom.prop("checked", false)
            $(this).siblings('.sub-box').hide();
        }else{
            $(this).siblings('.sub-box').toggle(this.checked);
        }
        
        if(this.checked) {
            var item =  `<li class="facil">
                            <p class="tit">${this.dataset.txt}</p>
                            <p class="info">${Number(this.dataset.pay).toLocaleString()}원</p>
                        </li>`;
            $("#add-opt").append(item).show();
        }
    });

    ReservationOrderCalc();
});

$('.step7-wrap .pay-wrap li').click((e) => {
    let paytype = $(e.currentTarget).data('type')

    $('input[name=pmethod]').val(paytype)

    $('.step7-wrap .pay-wrap li').removeClass('active')
    $(e.currentTarget).addClass('active')
})

$('.step7-wrap .btn-bnf').click((e) => {
    $('.popupBnf').show()
})
$('.popupBnf .btn-close').click((e) => {
    $('.popupBnf').hide()
})

$('.step7-wrap #check_all').change((e) => {
    if($(e.currentTarget).is(':checked')){
        $('.check-list input:checkbox').val('y')
    }
})

$('.step7-wrap input[type=checkbox]').change((e) => {
    $(e.currentTarget).is(':checked') ? $(e.currentTarget).val('y') : $(e.currentTarget).val('')
})
$('.step7-wrap .recipt-wrap .btn').click((e) => {
    $('.loading-wrap').show()
    const $form = $('#rsvform')
    const chk = formCheck($form)
    
    
    if(chk == true) {
        $form.submit();
    }else{
        $('.loading-wrap').hide()
    }
}) 

// 인증번호 찾기
let timers = {};
const startCountdown = (group, display) => {
    if (timers[group]) clearInterval(timers[group]);
    
    let minutes = 2;
    let seconds = 59;
    
    $(display).text("02:59");
    
    timers[group] = setInterval(() => {
        if (!minutes && !seconds) {
            clearInterval(timers[group]);
            alert('인증번호 입력 시간이 만료되었습니다. 인증번호를 재발송해 주세요.')
        } else {
            seconds = seconds === 0 ? (minutes--, 59) : seconds - 1;
        }
        
        $(display).text(`${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`);
    }, 1000);
    
};
const resetFields = () => {
    $(".popupfind .input").val("");
    $(".popupfind .codeInput").val("");
    $(".popupfind .input-wrap").removeClass("active");
    $(".popupfind .btn-ath").removeClass("second-click active").text("인증번호 발송");
    $(".popupfind .count").text("02:59");
    $('.popupfind form').show()
    $('.popupfind .cmp-wrap').hide()
    Object.keys(timers).forEach(group => clearInterval(timers[group]));
};

$('.popupfind input[type="radio"]').change((e) => {
    resetFields()
    $('.popupfind .form-wrap li').removeClass('active')
    $(e.currentTarget).closest('li').toggleClass('active')
})

$(".popupfind .fold .input").on("input", function() {
    const group = $(this).data("group");
    const inputs = $(`.input[data-group='${group}']`);
    const button = $(`.btn-ath[data-group='${group}']`);
    
    button.toggleClass("active", inputs.toArray().every(i => $(i).val().trim() !== ""));
});

$(".popupfind .btn-close, .popupfind .btn-close2").on("click", resetFields);

$('.btn-ath').click((e) => {
    let group = $(e.currentTarget).data('group')
    let inputs = $(`.input[data-group='${group}']`);
    let codeInput = $(`.codeInput[data-group='${group}']`);
    let display = $(`.count[data-group='${group}']`);
    
    if (!inputs.toArray().every(i => $(i).val().trim())) {
        return alert("이름과 휴대폰 번호 또는 이메일을 입력해주세요.");
    }

    const Form = $("#find");
    const formData = new FormData(Form[0]);
    const jsonObject = {};

    formData.forEach((value, key) => {
        jsonObject[key] = value;
    });
    
    
    if (!$(e.currentTarget).hasClass("second-click")) {
        fetch('/reserve/mypage/find', {            
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': $('meta[name=csrf-token]').attr('content'),
            },
            body: JSON.stringify(jsonObject),
        })
        .then((response) => response.json())
        .then((result) => {
            if(result.code == 300) {
                alert(result.res);
            } else {
                $(e.currentTarget).text("인증하기").siblings('.input-wrap').addClass('active');
                $(e.currentTarget).addClass("second-click");
                if (display.length) startCountdown(group, display);
                alert('인증번호가 발송되었습니다.\n인증번호를 입력창에 입력 후 인증하기 버튼을 눌러주세요.')
            }
        })
    } else {
        if (!codeInput.val().trim()) {
            return alert("인증번호를 입력해주세요.");
        }

        fetch('/reserve/mypage/auth', {            
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': $('meta[name=csrf-token]').attr('content'),
            },
            body: JSON.stringify(jsonObject),
        })
        .then((response) => response.json())
        .then((result) => {
            if(result.code == 300) {
                alert(result.res);                
            } else {
                $('.popupfind form').hide()
                $('.popupfind .cmp-wrap').show()
                $('.popupfind .cmp-wrap .main').html(result.res)

                // 인증번호 3개 이상
                if ($(".popupfind .cmp-wrap .main >li").length > 2) {
                    $(".popupfind .cmp-wrap .main").addClass("scroll");
                } else {
                    $(".popupfind .cmp-wrap .main").removeClass("scroll");
                }

                $(".btn-copy").on("click", function() {
                    const text = $(this).siblings(".num").text().trim();
                    navigator.clipboard.writeText(text).then(() => alert('인증번호가 복사 되었습니다.'));
                });
            }
        })
    }
})

$('.btn-resend').click((e) => {
    let group = $(e.currentTarget).data('group')
    let display = $(`.count[data-group='${group}']`);

    startCountdown(group, display)

    const Form = $("#find");
    const formData = new FormData(Form[0]);
    const jsonObject = {};

    formData.forEach((value, key) => {
        jsonObject[key] = value;
    });

    fetch('/reserve/mypage/find', {            
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRF-TOKEN': $('meta[name=csrf-token]').attr('content'),
        },
        body: JSON.stringify(jsonObject),
    })
    .then((response) => response.json())
    .then((result) => {
        if(result.code == 300) {
            alert(result.res);
        } else {
            $(e.currentTarget).addClass("second-click");
            if (display.length) startCountdown(group, display);
            alert('인증번호가 재발송되었습니다.\n인증번호를 입력창에 입력 후 인증하기 버튼을 눌러주세요.')
        }
    })

})

$('.popupMore #rsv-cancel').click((e) => {
    $('.loading-wrap').show()

    fetch("/reserve/mypage/cancel-membership", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "X-CSRF-TOKEN": $("meta[name=csrf-token]").attr("content"),
        },            
        body: JSON.stringify({                    
            uno:  $(e.currentTarget).data('serial'),
            pid:  $(e.currentTarget).data('pay'),
        }),
    })
    .then((response) => response.json())
    .then((data) => {       
        $('.loading-wrap').hide()
        if(data.res == 200) {
            alert('취소되었습니다.');
            location.href = '/reserve/mypage/cancel-membership-logout';
        } else {
            alert(data.msg)                
        }
    })
})

ReservationOrderCalc();